<template>
  <div id="reportOuter">
    <div>
      <h5>Report View - Unit Alert &amp; Error Report</h5>
      <div>
        <img
          id="menuGraphic"
          align="right"
          src="../assets/PDFIconSmall.png"
          v-on:click="createPDF()"
        />
        <img
          id="menuGraphic"
          align="right"
          src="../assets/excelSmall.png"
          v-on:click="
            exportTableToExcel(
              'AlertAndErrorReport',
              'Alert_And_Error_Report_Export_' + new Date().toLocaleDateString()
            )
          "
        />
        <br />
      </div>
      <b-pagination
        v-model="currentPage"
        :total-rows="rows"
        :per-page="perPage"
        aria-controls="AlertAndErrorReport"
      ></b-pagination>
    </div>
    <div id="Report">
      <b-table
        stacked="md"
        id="AlertAndErrorReport"
        striped
        hover
        :items="items"
        :fields="fields"
        :per-page="perPage"
        :current-page="currentPage"
        :sort-desc.sync="sortDesc"
        :sort-by.sync="sortBy"
        small
        label-sort-asc=""
        label-sort-desc=""
        label-sort-clear=""
      ></b-table>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      perPage: 100,
      currentPage: 1,
      fields: [
        {
          key: "UnitID",
          label: "Unit ID",
        },
        {
          key: "Location",
        },
        {
          key: "WardDept",
          label: "Ward/Dept",
        },
        {
          key: "UnitType",
          label: "Type",
        },
        {
          key: "CurrentState",
          label: "Current State",
        },
        {
          key: "Alarms",
        },
        {
          key: "Errors",
        },
      ],
      items: [
        {
          UnitID: "MIC7654323",
          Location: "Queen Elizabeth",
          WardDept: "ICU",
          UnitType: "Michael",
          CurrentState: "Alert",
          Alarms: "2",
          Errors: "0",
        },
        {
          UnitID: "GAB7654987",
          Location: "Glasgow Royal",
          WardDept: "HDU",
          UnitType: "Gabriel",
          CurrentState: "Alert",
          Alarms: "1",
          Errors: "0",
        },
        {
          UnitID: "MIC7698663",
          Location: "Queen Elizabeth",
          WardDept: "Ward 4",
          UnitType: "Michael",
          CurrentState: "Alert",
          Alarms: "1",
          Errors: "0",
        },
        {
          UnitID: "MIC7658752",
          Location: "Queen Elizabeth",
          WardDept: "A&E",
          UnitType: "Michael",
          CurrentState: "Error",
          Alarms: "0",
          Errors: "2",
        },
        {
          UnitID: "GAB2334323",
          Location: "Stobhill",
          WardDept: "Ward 1b",
          UnitType: "Gabriel",
          CurrentState: "Error",
          Alarms: "0",
          Errors: "1",
        },
        {
          UnitID: "MIC7687723",
          Location: "Queen Elizabeth",
          WardDept: "Ward 12",
          UnitType: "Michael",
          CurrentState: "Error",
          Alarms: "0",
          Errors: "1",
        },
        {
          UnitID: "MIC7009323",
          Location: "Queen Elizabeth",
          WardDept: "Ward 12",
          UnitType: "Michael",
          CurrentState: "Error",
          Alarms: "0",
          Errors: "1",
        },
        {
          UnitID: "GAB9624323",
          Location: "Inverclyde",
          WardDept: "Ward 3",
          UnitType: "Gabriel",
          CurrentState: "Maintenance",
          Alarms: "0",
          Errors: "0",
        },
        {
          UnitID: "GAB0654323",
          Location: "Gartnavel",
          WardDept: "Neo-Natal",
          UnitType: "Gabriel",
          CurrentState: "Maintenance",
          Alarms: "0",
          Errors: "0",
        },
        {
          UnitID: "MIC9865342",
          Location: "Glasgow Royal",
          WardDept: "A&E",
          UnitType: "Michael",
          CurrentState: "Active",
          Alarms: "0",
          Errors: "0",
        },
        {
          UnitID: "MIC7644423",
          Location: "Queen Elizabeth",
          WardDept: "ICU",
          UnitType: "Michael",
          CurrentState: "Active",
          Alarms: "0",
          Errors: "0",
        },
        {
          UnitID: "MIC7650111",
          Location: "Queen Elizabeth",
          WardDept: "ICU",
          UnitType: "Michael",
          CurrentState: "Active",
          Alarms: "0",
          Errors: "0",
        },
        {
          UnitID: "GAB0765120",
          Location: "Queen Elizabeth",
          WardDept: "Ward 9",
          UnitType: "Gabriel",
          CurrentState: "Active",
          Alarms: "0",
          Errors: "0",
        },
        {
          UnitID: "GAB7165241",
          Location: "Glasgow Royal",
          WardDept: "A&E",
          UnitType: "Gabriel",
          CurrentState: "Active",
          Alarms: "0",
          Errors: "0",
        },
        {
          UnitID: "MIC0983245",
          Location: "Glasgow Royal",
          WardDept: "A&E",
          UnitType: "Michael",
          CurrentState: "Active",
          Alarms: "0",
          Errors: "0",
        },
        {
          UnitID: "MIC0987652",
          Location: "Stobhill",
          WardDept: "Ward 2",
          UnitType: "Michael",
          CurrentState: "Active",
          Alarms: "0",
          Errors: "0",
        },
        {
          UnitID: "MIC9873566",
          Location: "Inverclyde",
          WardDept: "Ward 3C",
          UnitType: "Michael",
          CurrentState: "Active",
          Alarms: "0",
          Errors: "0",
        },
        {
          UnitID: "GAB1019287",
          Location: "Glasgow Royal",
          WardDept: "Renal",
          UnitType: "Gabriel",
          CurrentState: "Active",
          Alarms: "0",
          Errors: "0",
        },
        {
          UnitID: "GAB8726525",
          Location: "Queen Elizabeth",
          WardDept: "ICU",
          UnitType: "Gabriel",
          CurrentState: "Active",
          Alarms: "0",
          Errors: "0",
        },
        {
          UnitID: "MIC3456679",
          Location: "Stobhill",
          WardDept: "Ward 1b",
          UnitType: "Michael",
          CurrentState: "Active",
          Alarms: "0",
          Errors: "0",
        },
        {
          UnitID: "MIC2876987",
          Location: "Gartnavel",
          WardDept: "Neo-Natal",
          UnitType: "Michael",
          CurrentState: "Active",
          Alarms: "0",
          Errors: "0",
        },
      ],
    };
  },
  computed: {
    rows() {
      return this.items.length;
    },
  },
  methods: {
    exportTableToExcel: function(tableID, filename = "") {
      var downloadLink;
      var dataType = "application/vnd.ms-excel";
      var tableSelect = document.getElementById(tableID);
      var tableHTML = tableSelect.outerHTML.replace(/ /g, "%20");

      // Specify file name
      filename = filename ? filename + ".xls" : "excel_data.xls";

      // Create download link element
      downloadLink = document.createElement("a");

      document.body.appendChild(downloadLink);

      if (navigator.msSaveOrOpenBlob) {
        var blob = new Blob(["\ufeff", tableHTML], {
          type: dataType,
        });
        navigator.msSaveOrOpenBlob(blob, filename);
      } else {
        // Create a link to the file
        downloadLink.href = "data:" + dataType + ", " + tableHTML;

        // Setting the file name
        downloadLink.download = filename;

        //triggering the function
        downloadLink.click();
      }
    },

    createPDF: function() {
      var sTable = document.getElementById("Report").innerHTML;

      var style = "<style>";
      style = style + "table {width: 100%;font: 12px Verdana;}";
      style =
        style +
        "table, th, td {border: solid 1px #DDD; border-collapse: collapse;";
      style = style + "padding: 2px 3px;text-align: center;}";
      style = style + "</style>";

      // CREATE A WINDOW OBJECT.
      var win = window.open("", "", "height=700,width=700");

      win.document.write("<html><head>");
      win.document.write("<title>Alert and Error Report</title>"); // <title> FOR PDF HEADER.
      win.document.write(style); // ADD STYLE INSIDE THE HEAD TAG.
      win.document.write("</head>");
      win.document.write("<body>");
      win.document.write(sTable); // THE TABLE CONTENTS INSIDE THE BODY TAG.
      win.document.write("</body></html>");

      win.print(); // PRINT THE CONTENTS.

      win.document.close(); // CLOSE THE CURRENT WINDOW.

      win.close();
    },
  },
};
</script>

<style scoped></style>
